"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var clsx_1 = require("clsx");
var Grid_1 = require("@material-ui/core/Grid");
var contentLineStyles_1 = require("./contentLineStyles");
var core_1 = require("@material-ui/core");
var SingleContent = function (_a) {
    var content = _a.content, alignment = _a.alignment, className = _a.className, dataTest = _a.dataTest, vehicleText = _a.vehicleText;
    var style = contentLineStyles_1.default();
    return (<Grid_1.default container={true} direction="row" justifyContent={alignment} className={clsx_1.default([style[alignment], className])} data-test={dataTest}>
      <Grid_1.default item={true} md={12}>
        <core_1.Typography className={vehicleText && style.vehicleText}>{content}</core_1.Typography>
      </Grid_1.default>
    </Grid_1.default>);
};
exports.default = SingleContent;
